import {
  REFUND_PAYMENT_SCHEDULE_LOADING,
  REFUND_PAYMENT_SCHEDULE_SUCCESS,
  REFUND_PAYMENT_SCHEDULE_FAILED,
} from "../types";

interface RefundPaymentScheduleState {
  loading: boolean;
  data: any;
  error: string | null;
}

const initialState: RefundPaymentScheduleState = {
  loading: false,
  data: null,
  error: null,
};

const refundPaymentScheduleReducer = (
  state = initialState,
  action: any
): RefundPaymentScheduleState => {
  switch (action.type) {
    case REFUND_PAYMENT_SCHEDULE_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case REFUND_PAYMENT_SCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case REFUND_PAYMENT_SCHEDULE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default refundPaymentScheduleReducer;

